import { formatWeight } from '../../../helpers/formatters/formatWeight/formatWeight';
import { Weight } from '../../types';

export const serializeWeight = (raw: number): Weight => {
  if (raw < 0) {
    throw new Error('Вес не может быть отрицательным');
  }

  return {
    value: raw,
    valueFormatted: formatWeight(raw)
  } as Weight;
};
